import { FilenameParamSchema, BaseResponseSchema } from '../../schemas.js';
import { DeleteOrphanedFilesRequestSchema, DeleteOrphanedFilesResponseSchema, LinkFilesRequestSchema, LinkFilesResponseSchema, UploadDeleteQuerySchema, } from '../../schemas/tenant-upload.schemas.js';
import { TrackedMultipleFileUploadFormSchema, TrackedMultipleFileUploadResponseSchema, TrackedSingleFileUploadFormSchema, TrackedSingleFileUploadResponseSchema, } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/tenant/upload.routes.ts`. */
export const tenantUploadContract = {
    uploadFiles: {
        method: 'POST',
        path: '/tenant/upload/files',
        body: TrackedMultipleFileUploadFormSchema,
        bodyStyle: 'form-data',
        response: TrackedMultipleFileUploadResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 120000,
        errorMessage: 'Failed to upload files',
    },
    uploadSingle: {
        method: 'POST',
        path: '/tenant/upload/single',
        body: TrackedSingleFileUploadFormSchema,
        bodyStyle: 'form-data',
        response: TrackedSingleFileUploadResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 120000,
        errorMessage: 'Failed to upload file',
    },
    deleteUploadedFile: {
        method: 'DELETE',
        path: '/tenant/upload/:filename',
        pathParams: FilenameParamSchema,
        query: UploadDeleteQuerySchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to delete uploaded file',
    },
    linkFiles: {
        method: 'POST',
        path: '/tenant/upload/link-files',
        body: LinkFilesRequestSchema,
        response: LinkFilesResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to link uploaded files',
    },
    deleteOrphanedFiles: {
        method: 'POST',
        path: '/tenant/upload/delete-orphaned',
        body: DeleteOrphanedFilesRequestSchema,
        response: DeleteOrphanedFilesResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to delete orphaned files',
    },
};
//# sourceMappingURL=tenant-upload.contract.js.map